import {
  AfterViewInit,
  Directive,
  DestroyRef,
  ElementRef,
  inject,
} from '@angular/core';

@Directive({
  selector: '[appRemoveQuillTooltip]',
  standalone: true,
})
export class RemoveQuillTooltipDirective implements AfterViewInit {
  readonly #elementRef = inject(ElementRef<HTMLElement>);
  readonly #destroyRef = inject(DestroyRef);
  #editorObserver?: MutationObserver;

  constructor() {
    this.#destroyRef.onDestroy(() => this.#editorObserver?.disconnect());
  }

  ngAfterViewInit(): void {
    const hostElement = this.#elementRef.nativeElement;

    this.#removeEditorTooltip();

    this.#editorObserver = new MutationObserver(() => {
      this.#removeEditorTooltip();
    });

    this.#editorObserver.observe(hostElement, {
      childList: true,
      subtree: true,
    });
  }

  #removeEditorTooltip(): void {
    const tooltip = this.#elementRef.nativeElement.querySelector('.ql-tooltip');
    tooltip?.remove();
  }
}
